function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var PublishTemplate = require('./publish.template');
var Photo = require('./photo');
var Passport = require('./passport');
var IdentityPrompt = require('./identity');
var WhoTemplate = require('./who.template');
var flow = require('./publish.flow');
var _require = require('./publish.share'),
  requirementLines = _require.requirementLines;
var _require2 = require('../../auth'),
  verifyEmailSignature = _require2.verifyEmailSignature,
  verifyPhoto = _require2.verifyPhoto,
  addSignature = _require2.addSignature,
  addInitial = _require2.addInitial,
  actionStatus = _require2.actionStatus,
  verifyActionSignature = _require2.verifyActionSignature,
  clearEmailIdentifier = _require2.clearEmailIdentifier,
  rememberEmail = _require2.rememberEmail,
  verifiedMethods = _require2.verifiedMethods,
  verifyPassport = _require2.verifyPassport,
  validVerification = _require2.validVerification,
  verifyCreatorProof = _require2.verifyCreatorProof,
  finalizeDocument = _require2.finalizeDocument,
  unfinalizeDocument = _require2.unfinalizeDocument,
  verifyFinalization = _require2.verifyFinalization,
  signingConfigurationError = _require2.signingConfigurationError,
  commitmentIntact = _require2.commitmentIntact,
  verificationSatisfied = _require2.verificationSatisfied,
  knownSigner = _require2.knownSigner;
var _require3 = require('../../document'),
  addUser = _require3.addUser,
  copy = _require3.copy,
  resolveSigner = _require3.resolveSigner;
var _require4 = require('../../draft'),
  saveDraft = _require4.saveDraft;
var _require5 = require('../../transaction'),
  shareMetadata = _require5.shareMetadata;
var PublishOverlay = /*#__PURE__*/function () {
  function PublishOverlay(app, mod) {
    _classCallCheck(this, PublishOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, true);
    this.overlay["class"] = 'saito-overlay saitosign-publish-host';
    this.state = flow.initialState();
    this.sliding = false;
    this.passport = new Passport();
    this.whoOverlay = new SaitoOverlay(app, mod, true);
    this.whoOverlay["class"] = 'saito-overlay saitosign-overlay';
  }
  return _createClass(PublishOverlay, [{
    key: "render",
    value: function render() {
      var _this$mod$document,
        _this$mod$document2,
        _this$mod$document3,
        _this$mod$document4,
        _this = this;
      this.state = flow.initialState();
      var metadata = (_this$mod$document = this.mod.document) === null || _this$mod$document === void 0 ? void 0 : _this$mod$document.metadata;
      if (metadata) {
        this.state = flow.applyShareMetadata(this.state, metadata);
      }
      this.state.signers = readUsers(this.mod);
      var walletKey = this.currentPublicKey();
      var owner = this.normalizePublicKey((_this$mod$document2 = this.mod.document) === null || _this$mod$document2 === void 0 ? void 0 : _this$mod$document2.creator);
      this.state.tierOwner = owner;
      this.state.canChooseTier = Boolean(!((_this$mod$document3 = this.mod.document) !== null && _this$mod$document3 !== void 0 && _this$mod$document3.finalized) && ((_this$mod$document4 = this.mod.document) === null || _this$mod$document4 === void 0 || (_this$mod$document4 = _this$mod$document4.creatorProof) === null || _this$mod$document4 === void 0 ? void 0 : _this$mod$document4.signature) && verifyCreatorProof(this.app, this.mod.document) && walletKey && owner && walletKey === owner);
      var known = knownSigner(this.app, this.state.signers);
      if (known) {
        this.keepUser(known);
      } else {
        this.state.signers = this.state.signers.filter(function (signer) {
          return signaturePlaces(_this.mod, signer.index) > 0;
        });
      }
      this.state = flow.resolveInitial(this.state, this.workflowRequirements(this.state.canChooseTier));
      if (this.state.step === 'share') {
        this.state = this.summaryState(this.state);
      }
      this.overlay.show(PublishTemplate(this.state));
      this.attachEvents();
    }
  }, {
    key: "openStatus",
    value: function openStatus() {
      var completionNote = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var record = this.mod.document;
      if (!(record !== null && record !== void 0 && record.finalized) || !verifyFinalization(this.app, record)) {
        var _this$mod$main;
        (_this$mod$main = this.mod.main) === null || _this$mod$main === void 0 || _this$mod$main.fail('The finalized document creator signature is invalid.');
        return;
      }
      this.state = flow.initialState();
      if (record.metadata) {
        this.state = flow.applyShareMetadata(this.state, record.metadata);
      }
      this.state.signers = readUsers(this.mod);
      this.state = _objectSpread(_objectSpread({}, this.summaryState(this.state)), {}, {
        step: 'share',
        history: [],
        allowUnfinalize: false,
        completionNote: String(completionNote || '')
      });
      this.overlay.show(PublishTemplate(this.state));
      this.attachEvents();
    }
  }, {
    key: "beginVerification",
    value: function beginVerification(signerIndex, actionId) {
      var record = this.mod.document;
      var signer = readUsers(this.mod).find(function (candidate) {
        return candidate.index === signerIndex;
      });
      if (!(record !== null && record !== void 0 && record.finalized) || !signer || !Number.isInteger(Number(actionId))) {
        return;
      }
      this.state = flow.initialState();
      if (record.metadata) {
        this.state = flow.applyShareMetadata(this.state, record.metadata);
      }
      this.state.signers = readUsers(this.mod);
      this.keepUser(signer);
      this.state = _objectSpread(_objectSpread({}, this.state), {}, {
        step: 'verify',
        history: [],
        allowUnfinalize: false,
        afterVerify: 'sign',
        pendingActionId: Number(actionId)
      });
      this.overlay.show(PublishTemplate(this.state));
      this.attachEvents();
    }
  }, {
    key: "commitFinalization",
    value: function () {
      var _commitFinalization = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$mod$document5;
        var ready, record, creator, _this$mod$main2, problem, _this$mod$main3, snapshot, finalized, _this$mod$main4, saved, _this$mod$main5, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(this.sliding || this.state.step !== 'share' || (_this$mod$document5 = this.mod.document) !== null && _this$mod$document5 !== void 0 && _this$mod$document5.finalized)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.sliding = true;
              ready = false;
              _context.p = 2;
              this.writeShare();
              record = this.mod.document;
              creator = String((record === null || record === void 0 ? void 0 : record.creator) || '').trim();
              if (!(!record || !creator)) {
                _context.n = 3;
                break;
              }
              (_this$mod$main2 = this.mod.main) === null || _this$mod$main2 === void 0 || _this$mod$main2.fail('This document could not be finalized.');
              return _context.a(2);
            case 3:
              problem = signingConfigurationError(record);
              if (!problem) {
                _context.n = 4;
                break;
              }
              (_this$mod$main3 = this.mod.main) === null || _this$mod$main3 === void 0 || _this$mod$main3.fail(problem);
              return _context.a(2);
            case 4:
              snapshot = {
                finalized: record.finalized,
                finalization: record.finalization ? JSON.parse(JSON.stringify(record.finalization)) : null,
                creatorProof: record.creatorProof ? JSON.parse(JSON.stringify(record.creatorProof)) : null,
                edited: record.edited,
                hash: String(record.hash || '')
              };
              _context.n = 5;
              return finalizeDocument(this.app, record, creator);
            case 5:
              finalized = _context.v;
              if (!(!finalized || !verifyFinalization(this.app, record) || !verifyCreatorProof(this.app, record))) {
                _context.n = 6;
                break;
              }
              record.finalized = snapshot.finalized;
              record.finalization = snapshot.finalization;
              record.creatorProof = snapshot.creatorProof;
              record.edited = snapshot.edited;
              record.hash = snapshot.hash;
              (_this$mod$main4 = this.mod.main) === null || _this$mod$main4 === void 0 || _this$mod$main4.fail('This document could not be finalized.');
              return _context.a(2);
            case 6:
              if (record.metadata) {
                saved = flow.applyShareMetadata(this.state, record.metadata);
                this.state = _objectSpread(_objectSpread({}, this.state), {}, {
                  plan: saved.plan,
                  options: saved.options
                });
              }
              this.state = this.summaryState(_objectSpread(_objectSpread({}, this.state), {}, {
                allowUnfinalize: false
              }));
              this.refreshWorkspace();
              ready = true;
              _context.n = 8;
              break;
            case 7:
              _context.p = 7;
              _t = _context.v;
              (_this$mod$main5 = this.mod.main) === null || _this$mod$main5 === void 0 || _this$mod$main5.fail('This document could not be finalized.');
            case 8:
              _context.p = 8;
              this.sliding = false;
              return _context.f(8);
            case 9:
              if (ready) {
                this.paintSlide();
              }
            case 10:
              return _context.a(2);
          }
        }, _callee, this, [[2, 7, 8, 9]]);
      }));
      function commitFinalization() {
        return _commitFinalization.apply(this, arguments);
      }
      return commitFinalization;
    }()
  }, {
    key: "reopenTier",
    value: function () {
      var _reopenTier = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var ready, reopened, _this$mod$main6, _this$mod$main7, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(this.sliding || this.state.step !== 'share' || !this.state.allowUnfinalize)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this.sliding = true;
              ready = false;
              _context2.p = 2;
              _context2.n = 3;
              return unfinalizeDocument(this.app, this.mod.document);
            case 3:
              reopened = _context2.v;
              if (reopened) {
                _context2.n = 4;
                break;
              }
              (_this$mod$main6 = this.mod.main) === null || _this$mod$main6 === void 0 || _this$mod$main6.fail('Only the document creator can change this finalized document.');
              return _context2.a(2);
            case 4:
              this.state = _objectSpread(_objectSpread({}, flow.back(this.state)), {}, {
                allowUnfinalize: false
              });
              this.refreshWorkspace();
              ready = true;
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t2 = _context2.v;
              (_this$mod$main7 = this.mod.main) === null || _this$mod$main7 === void 0 || _this$mod$main7.fail('Only the document creator can change this finalized document.');
            case 6:
              _context2.p = 6;
              this.sliding = false;
              return _context2.f(6);
            case 7:
              if (!ready) {
                _context2.n = 8;
                break;
              }
              _context2.n = 8;
              return this.showStep('back');
            case 8:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 5, 6, 7]]);
      }));
      function reopenTier() {
        return _reopenTier.apply(this, arguments);
      }
      return reopenTier;
    }()
  }, {
    key: "refreshWorkspace",
    value: function refreshWorkspace() {
      var _this$mod$main8;
      var workspace = (_this$mod$main8 = this.mod.main) === null || _this$mod$main8 === void 0 ? void 0 : _this$mod$main8.workspace;
      var root = document.querySelector('.saito-container > .workspace');
      if (workspace && root) {
        workspace.update(root);
      }
    }
  }, {
    key: "close",
    value: function close() {
      this.overlay.close();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.state = flow.initialState();
      this.close();
    }
  }, {
    key: "showStep",
    value: function () {
      var _showStep = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(direction) {
        var panel, actionBar, exitClass, enterClass, temp, next, nextActions;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!this.sliding) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this.sliding = true;
              panel = document.querySelector('#saitosign-publish-step');
              actionBar = document.querySelector('.saitosign-publish .actions');
              if (panel) {
                _context3.n = 2;
                break;
              }
              this.sliding = false;
              this.overlay.show(PublishTemplate(this.state));
              this.attachEvents();
              return _context3.a(2);
            case 2:
              exitClass = direction === 'back' ? 'slide-exit-right' : 'slide-exit-left';
              enterClass = direction === 'back' ? 'slide-enter-left' : 'slide-enter-right';
              panel.classList.add(exitClass);
              _context3.n = 3;
              return wait(180);
            case 3:
              temp = document.createElement('div');
              temp.innerHTML = PublishTemplate(this.state).trim();
              next = temp.querySelector('#saitosign-publish-step');
              nextActions = temp.querySelector('.saitosign-publish .actions');
              if (!next) {
                _context3.n = 4;
                break;
              }
              next.classList.add(enterClass);
              panel.replaceWith(next);
              _context3.n = 4;
              return new Promise(function (resolve) {
                requestAnimationFrame(function () {
                  requestAnimationFrame(function () {
                    next.classList.remove(enterClass);
                    resolve();
                  });
                });
              });
            case 4:
              if (actionBar && nextActions) {
                actionBar.replaceWith(nextActions);
              }
              this.attachEvents();
              _context3.n = 5;
              return wait(220);
            case 5:
              this.sliding = false;
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function showStep(_x) {
        return _showStep.apply(this, arguments);
      }
      return showStep;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var root = document.querySelector('.saitosign-publish');
      if (!root) {
        return;
      }
      this.passport.attach(root, {
        onUpload: function onUpload(image) {
          return _this2.acceptPassport(image);
        },
        onRemove: function onRemove() {
          return _this2.removePassport();
        },
        onError: function onError(message) {
          _this2.state = _objectSpread(_objectSpread({}, _this2.state), {}, {
            passportError: message
          });
          _this2.paintSlide();
        }
      });
      if (root.dataset.bound === '1') return;
      root.dataset.bound = '1';
      root.addEventListener('change', function (event) {
        var option = event.target.closest('[data-share-option]');
        if (option && _this2.state.step === 'select' && _this2.state.canChooseTier) {
          _this2.state = flow.setShareOption(_this2.state, option.dataset.shareOption, option.checked);
          _this2.writeShare();
          return;
        }
        var select = event.target.closest('[data-you-signer]');
        if (!select) {
          return;
        }
        var extra = root.querySelector('[data-new-signer]');
        if (!extra) {
          return;
        }
        extra.hidden = select.value !== 'new';
        if (!extra.hidden) {
          var _root$querySelector;
          (_root$querySelector = root.querySelector('[data-new-signer-name]')) === null || _root$querySelector === void 0 || _root$querySelector.focus();
        }
      });
      root.addEventListener('click', function (event) {
        var plan = event.target.closest('[data-plan]');
        if (plan && _this2.state.step === 'select') {
          if (!_this2.state.canChooseTier) {
            return;
          }
          _this2.state = flow.selectPlan(_this2.state, plan.dataset.plan);
          _this2.paintSlide();
          return;
        }
        var action = event.target.closest('[data-publish-action]');
        if (!action || action.disabled || _this2.sliding) {
          return;
        }
        if (action.dataset.publishAction === 'confirm-you') {
          _this2.confirmYou();
          return;
        }
        if (action.dataset.publishAction === 'add-signer') {
          _this2.addSigner();
          return;
        }
        if (action.dataset.publishAction === 'send-email') {
          _this2.sendEmail();
          return;
        }
        if (action.dataset.publishAction === 'submit-signature') {
          _this2.submitSignature();
          return;
        }
        if (action.dataset.publishAction === 'backup') {
          _this2.showBackup();
          return;
        }
        if (action.dataset.publishAction === 'back') {
          if (_this2.state.step === 'share') {
            if (_this2.state.finalized) {
              return;
            }
            var previous = flow.back(_this2.state);
            if (previous === _this2.state) {
              return;
            }
            _this2.state = previous;
            _this2.showStep('back');
            return;
          }
          var next = flow.back(_this2.state);
          if (next === _this2.state) {
            return;
          }
          _this2.state = next;
          _this2.showStep('back');
          return;
        }
        if (action.dataset.publishAction === 'premium') {
          _this2.state = flow.learnPremium(_this2.state);
          _this2.showStep('forward');
          return;
        }
        if (action.dataset.publishAction === 'method') {
          _this2.state = flow.focusMethod(_this2.state, action.dataset.method);
          _this2.paintSlide();
          return;
        }
        if (action.dataset.publishAction === 'take-photo') {
          _this2.takePhoto();
          return;
        }
        if (action.dataset.publishAction === 'review') {
          _this2.close();
          return;
        }
        if (action.dataset.publishAction === 'share') {
          _this2.mod.exportDocument();
          return;
        }
        if (action.dataset.publishAction === 'finalize') {
          _this2.commitFinalization();
          return;
        }
        if (action.dataset.publishAction === 'sign-now') {
          _this2.showWhoAreYou();
          return;
        }
        if (action.dataset.publishAction === 'skip-sign') {
          _this2.state = _objectSpread(_objectSpread({}, _this2.state), {}, {
            distributeOnly: true
          });
          _this2.paintSlide();
          return;
        }
        if (action.dataset.publishAction === 'upload-share') {
          var notice = 'Upload and share is not implemented yet.';
          if (typeof salert === 'function') {
            salert(notice);
          } else {
            alert(notice);
          }
          return;
        }
        if (action.dataset.publishAction === 'export-draft') {
          _this2.confirmDraftExport();
          return;
        }
        if (action.dataset.publishAction === 'close') {
          _this2.close();
          return;
        }
        if (action.dataset.publishAction === 'advance') {
          if (_this2.state.step === 'select') {
            _this2.writeShare();
            _this2.state = flow.go(_this2.state, 'share', {
              allowUnfinalize: false
            });
            _this2.state = _this2.summaryState(_this2.state);
            _this2.showStep('forward');
            return;
          }
          if (_this2.state.step === 'verify') {
            _this2.continueAfterVerification();
            return;
          }
          if (_this2.state.step === 'sign') {
            _this2.continueAfterSigning();
            return;
          }
          var _next2 = flow.advance(_this2.state, _this2.workflowRequirements());
          if (_next2 === _this2.state) {
            return;
          }
          _this2.state = _this2.withKnownVerifications(_next2);
          if (_this2.state.step === 'share') {
            _this2.state = _this2.summaryState(_this2.state);
          }
          _this2.writeShare();
          _this2.showStep('forward');
        }
      });
    }
  }, {
    key: "confirmDraftExport",
    value: function () {
      var _confirmDraftExport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var confirmed;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return sconfirm('You are exporting a SaitoSign document that is not yet prepared for others to sign. Import this file back into SaitoSign anytime to continue...');
            case 1:
              confirmed = _context4.v;
              if (confirmed) {
                this.mod.exportDocument({
                  draft: true
                });
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function confirmDraftExport() {
        return _confirmDraftExport.apply(this, arguments);
      }
      return confirmDraftExport;
    }()
  }, {
    key: "paintPlan",
    value: function paintPlan() {
      var _this3 = this;
      var root = document.querySelector('.saitosign-publish');
      if (!root) {
        return;
      }
      root.querySelectorAll('[data-plan]').forEach(function (button) {
        var selected = button.dataset.plan === _this3.state.plan;
        button.classList.toggle('active', selected);
        button.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      root.querySelectorAll('[data-tier-feature]').forEach(function (feature) {
        var included = _this3.state.plan === 'premium' || feature.dataset.freeAvailable === 'true';
        feature.classList.toggle('included', included);
        feature.classList.toggle('unavailable', !included);
        var indicator = feature.querySelector('.feature-indicator');
        if (indicator) {
          indicator.textContent = '';
          indicator.setAttribute('aria-label', included ? 'Included with this tier' : 'Not available on this tier');
        }
      });
    }
  }, {
    key: "writeShare",
    value: function writeShare() {
      var record = this.mod.document;
      if (!record || record.finalized) {
        return;
      }
      if (!this.state.canChooseTier && record.metadata) {
        return;
      }
      record.metadata = shareMetadata(this.state.plan, this.state.options, this.state.tierOwner);
    }
  }, {
    key: "currentPublicKey",
    value: function currentPublicKey() {
      var _this$app$wallet;
      return this.normalizePublicKey((_this$app$wallet = this.app.wallet) === null || _this$app$wallet === void 0 ? void 0 : _this$app$wallet.publicKey);
    }
  }, {
    key: "normalizePublicKey",
    value: function normalizePublicKey(value) {
      var publickey = String(value || '').trim();
      if (/^[0-9a-fA-F]+$/.test(publickey) && publickey.length >= 64) {
        publickey = this.app.crypto.compressPublicKey(publickey);
      }
      return publickey;
    }
  }, {
    key: "confirmYou",
    value: function confirmYou() {
      var select = document.querySelector('[data-you-signer]');
      var raw = select === null || select === void 0 ? void 0 : select.value;
      if (!raw || raw === 'new') {
        return;
      }
      var index = Number(raw);
      var signer = this.state.signers.find(function (candidate) {
        return candidate.index === index;
      });
      if (!signer) {
        return;
      }
      this.keepUser(signer);
      this.continueAfterIdentity();
    }
  }, {
    key: "showWhoAreYou",
    value: function showWhoAreYou() {
      var _this4 = this;
      if (!this.state.finalized) {
        return;
      }
      var signers = shareRowsForWho(this.state);
      if (!signers.length) {
        return;
      }
      this.whoOverlay.show(WhoTemplate(signers));
      var root = document.querySelector('.saitosign-who');
      if (!root) {
        return;
      }
      root.addEventListener('click', function (event) {
        var choice = event.target.closest('[data-who-signer]');
        if (!choice) {
          return;
        }
        event.preventDefault();
        var index = Number(choice.dataset.whoSigner);
        var signer = _this4.state.signers.find(function (candidate) {
          return candidate.index === index;
        });
        if (!signer) {
          return;
        }
        _this4.whoOverlay.close();
        var prompt = new IdentityPrompt(_this4.app, _this4.mod);
        prompt.render(signer.name || signer.email || '', {
          onYes: function onYes() {
            return _this4.beginSigningAs(signer);
          }
        });
      });
    }
  }, {
    key: "beginSigningAs",
    value: function beginSigningAs(signer) {
      if (!signer || !this.state.finalized) {
        return;
      }
      this.keepUser(signer);
      var actionId = firstUnsignedActionId(this.app, this.mod.document, signer.index);
      this.state = flow.go(this.state, 'verify', {
        afterVerify: 'sign',
        pendingActionId: actionId,
        allowUnfinalize: false,
        verifyError: ''
      });
      this.state = this.withKnownVerifications(this.state);
      this.showStep('forward');
    }
  }, {
    key: "addSigner",
    value: function addSigner() {
      var _this$mod$document6, _this$app$wallet2;
      if (!this.state.canChooseTier || (_this$mod$document6 = this.mod.document) !== null && _this$mod$document6 !== void 0 && _this$mod$document6.finalized) {
        return;
      }
      var input = document.querySelector('[data-new-signer-name]');
      var value = input === null || input === void 0 ? void 0 : input.value.trim();
      if (!value) {
        return;
      }
      var email = isEmailAddress(value) ? value : '';
      var name = email ? nameFromEmail(email) : value;
      var decision = resolveSigner(this.mod.document, value, email ? name : undefined);
      if (decision.action === 'existing') {
        if (decision.conflict) {
          duplicateSignerNotice();
          return;
        }
        this.state.signers = readUsers(this.mod);
        var existing = this.state.signers.find(function (candidate) {
          return candidate.index === decision.index;
        });
        if (!existing) {
          return;
        }
        this.keepUser(existing);
        this.continueAfterIdentity();
        if (input) {
          input.value = '';
        }
        return;
      }
      var index = addUser(this.mod.document, name, (_this$app$wallet2 = this.app.wallet) === null || _this$app$wallet2 === void 0 ? void 0 : _this$app$wallet2.publicKey);
      if (index < 0) {
        return;
      }
      if (email) {
        this.mod.document.users[index].email = email;
      }
      this.state.signers = readUsers(this.mod);
      var added = this.state.signers.find(function (candidate) {
        return candidate.index === index;
      });
      if (!added) {
        return;
      }
      this.keepUser(added);
      this.continueAfterIdentity();
    }
  }, {
    key: "keepUser",
    value: function keepUser(signer) {
      var _this$app$wallet3,
        _this5 = this;
      var email = signer.email || (isEmailAddress(signer.name) ? signer.name : '');
      // The public key and identicon come from the wallet and keychain.
      // Email and every verification belong to this document's signer record.
      var publickey = String(((_this$app$wallet3 = this.app.wallet) === null || _this$app$wallet3 === void 0 ? void 0 : _this$app$wallet3.publicKey) || '').trim();
      if (/^[0-9a-fA-F]+$/.test(publickey) && publickey.length >= 64) {
        publickey = this.app.crypto.compressPublicKey(publickey);
      }
      var identicon = this.app.keychain.returnIdenticon(publickey) || '';
      var you = {
        index: signer.index,
        name: signer.name,
        email: email,
        publicKey: publickey,
        identicon: identicon
      };
      var live = this.mod.document.users[signer.index];
      if (live) {
        var previousPublickey = String(live.publickey || '').trim();
        if (email) {
          live.email = email;
        }
        live.publickey = publickey;
        var verifications = Array.isArray(live.verifications) ? live.verifications : [];
        var stalePhoto = verifications.some(function (entry) {
          var method = String((entry === null || entry === void 0 ? void 0 : entry.method) || '').trim();
          return (method === 'photo' || !method && String((entry === null || entry === void 0 ? void 0 : entry.message) || '').startsWith('Photo received for verification of publickey ')) && !validVerification(_this5.app, entry, live);
        });
        var stalePassport = verifications.some(function (entry) {
          return String((entry === null || entry === void 0 ? void 0 : entry.method) || '').trim() === 'passport' && !validVerification(_this5.app, entry, live);
        });
        var validVerifications = verifications.filter(function (entry) {
          return validVerification(_this5.app, entry, live);
        });
        if (validVerifications.length !== verifications.length || previousPublickey !== publickey) {
          live.verifications = validVerifications;
          this.mod.document.edited = true;
        }
        if (stalePhoto || stalePassport) {
          this.state = _objectSpread(_objectSpread({}, this.state), {}, {
            verificationMethods: this.state.verificationMethods.map(function (method) {
              return method.id === 'photo' && stalePhoto || method.id === 'passport' && stalePassport ? _objectSpread(_objectSpread({}, method), {}, {
                required: true,
                selected: true,
                status: 'pending'
              }) : method;
            })
          });
        }
      }
      this.state = flow.confirmYou(this.state, you);
      this.state.places = signaturePlaces(this.mod, you.index);
      this.state = this.withKnownVerifications(this.state);
    }
  }, {
    key: "withKnownVerifications",
    value: function withKnownVerifications(state) {
      var _this$mod$document7, _state$you;
      var live = (_this$mod$document7 = this.mod.document) === null || _this$mod$document7 === void 0 || (_this$mod$document7 = _this$mod$document7.users) === null || _this$mod$document7 === void 0 ? void 0 : _this$mod$document7[(_state$you = state.you) === null || _state$you === void 0 ? void 0 : _state$you.index];
      var known = verifiedMethods(this.app, live);
      var image = storedPhoto(live);
      var passport = storedPassport(live);
      var verificationMethods = (state.verificationMethods || []).map(function (method) {
        if (!method.required) {
          return method;
        }
        if (!known.includes(method.id)) {
          return method.status === 'verified' ? _objectSpread(_objectSpread({}, method), {}, {
            status: 'pending'
          }) : method;
        }
        var next = method.status === 'verified' ? method : _objectSpread(_objectSpread({}, method), {}, {
          status: 'verified',
          selected: true
        });
        if (method.id === 'photo' && image) {
          return _objectSpread(_objectSpread({}, next), {}, {
            photo: image
          });
        }
        if (method.id === 'passport' && passport) {
          return _objectSpread(_objectSpread({}, next), {}, {
            image: passport
          });
        }
        return next;
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        verificationMethods: verificationMethods
      });
    }
  }, {
    key: "workflowRequirements",
    value: function workflowRequirements() {
      var _this$state$you;
      var newDocument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var identified = Boolean(this.state.identified && this.state.you);
      var index = (_this$state$you = this.state.you) === null || _this$state$you === void 0 ? void 0 : _this$state$you.index;
      return {
        newDocument: newDocument,
        identified: identified,
        outstandingSignatures: identified && signaturePlaces(this.mod, index) > 0,
        verificationComplete: identified && flow.requiredComplete(this.state)
      };
    }
  }, {
    key: "continueAfterIdentity",
    value: function continueAfterIdentity() {
      if (!this.state.identified || !this.state.you) {
        return;
      }
      this.state = flow.resolveAfter(this.state, 'identity', this.workflowRequirements());
      if (this.state.step === 'share') {
        this.state = this.summaryState(this.state);
      }
      this.writeShare();
      this.showStep('forward');
    }
  }, {
    key: "continueAfterSigning",
    value: function () {
      var _continueAfterSigning = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _record$users;
        var record, user, signed, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!(!this.state.identified || !this.state.you || this.sliding)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              record = this.mod.document;
              user = record === null || record === void 0 || (_record$users = record.users) === null || _record$users === void 0 ? void 0 : _record$users[this.state.you.index];
              if (!(user && !verificationSatisfied(this.app, record, user))) {
                _context5.n = 2;
                break;
              }
              this.state = this.withKnownVerifications(this.state);
              this.state = flow.go(this.state, 'verify', {
                verifyError: ''
              });
              this.showStep('forward');
              return _context5.a(2);
            case 2:
              _context5.p = 2;
              _context5.n = 3;
              return this.signUserActions();
            case 3:
              signed = _context5.v;
              if (signed) {
                _context5.n = 4;
                break;
              }
              this.showSignError('Could not sign these actions with the current wallet key.');
              return _context5.a(2);
            case 4:
              _context5.n = 6;
              break;
            case 5:
              _context5.p = 5;
              _t3 = _context5.v;
              this.showSignError('Could not sign these actions. Please try again.');
              return _context5.a(2);
            case 6:
              this.state.places = signaturePlaces(this.mod, this.state.you.index);
              if (!(this.state.places > 0)) {
                _context5.n = 7;
                break;
              }
              this.showSignError('Some actions still need a valid signature.');
              return _context5.a(2);
            case 7:
              this.refreshActions();
              // Signing is followed by the verification stage in this flow, even when
              // this signer already has every selected proof on file.
              this.state = flow.go(this.state, 'verify', {
                places: 0,
                verifyError: ''
              });
              this.showStep('forward');
            case 8:
              return _context5.a(2);
          }
        }, _callee5, this, [[2, 5]]);
      }));
      function continueAfterSigning() {
        return _continueAfterSigning.apply(this, arguments);
      }
      return continueAfterSigning;
    }()
  }, {
    key: "showSignError",
    value: function showSignError(message) {
      var root = document.querySelector('.saitosign-publish');
      if (!root) return;
      var note = root.querySelector('[data-sign-error]');
      if (!note) {
        var _root$querySelector2;
        note = document.createElement('p');
        note.className = 'note fail';
        note.dataset.signError = '1';
        (_root$querySelector2 = root.querySelector('.sign-step')) === null || _root$querySelector2 === void 0 || _root$querySelector2.appendChild(note);
      }
      if (note) note.textContent = message;
    }
  }, {
    key: "sendEmail",
    value: function sendEmail() {
      var _this$state$you2,
        _this$state$you3,
        _this$app$wallet4,
        _this6 = this;
      var input = document.querySelector('[data-verify-email]');
      var email = ((input === null || input === void 0 ? void 0 : input.value) || ((_this$state$you2 = this.state.you) === null || _this$state$you2 === void 0 ? void 0 : _this$state$you2.email) || '').trim();
      var publickey = ((_this$state$you3 = this.state.you) === null || _this$state$you3 === void 0 ? void 0 : _this$state$you3.publicKey) || '';
      if (!email || !publickey || !this.state.you) {
        this.state = _objectSpread(_objectSpread({}, this.state), {}, {
          verifyError: 'Enter an email address to verify.'
        });
        this.paintSlide();
        return;
      }
      clearEmailIdentifier(this.app, publickey);
      clearEmailIdentifier(this.app, (_this$app$wallet4 = this.app.wallet) === null || _this$app$wallet4 === void 0 ? void 0 : _this$app$wallet4.publicKey);
      var live = this.mod.document.users[this.state.you.index];
      if (live) {
        live.email = email;
      }
      this.state = _objectSpread(_objectSpread({}, this.state), {}, {
        you: _objectSpread(_objectSpread({}, this.state.you), {}, {
          email: email
        }),
        verifyError: ''
      });
      if (!mailServerReachable(this.app)) {
        this.showMailUnreachable();
        return;
      }
      var request = {
        done: false
      };
      var timer = setTimeout(function () {
        if (request.done) {
          return;
        }
        request.done = true;
        _this6.showMailUnreachable();
      }, 8000);
      var finish = function finish(apply) {
        if (request.done) {
          return;
        }
        request.done = true;
        clearTimeout(timer);
        apply();
      };
      var sent;
      try {
        sent = this.app.network.sendRequestAsTransaction('saitosign verify email', {
          email: email,
          publickey: publickey
        }, function (res) {
          finish(function () {
            if (res !== null && res !== void 0 && res.publickey) {
              _this6.serverkey = res.publickey;
            }
            if (res !== null && res !== void 0 && res.success && res.publickey) {
              _this6.keepVerification(res, email, publickey).then(function () {
                _this6.rememberDevCode(res);
                _this6.paintSlide();
              })["catch"](function () {
                _this6.state = _objectSpread(_objectSpread({}, _this6.state), {}, {
                  verifyError: 'This server cannot send a verification email.'
                });
                _this6.paintSlide();
              });
              return;
            }
            if (res !== null && res !== void 0 && res.error && _this6.serverkey) {
              _this6.state = flow.markMethodSent(_this6.state, 'email');
              _this6.rememberDevCode(res);
              _this6.paintSlide();
              return;
            }
            if (!res) {
              _this6.showMailUnreachable();
              return;
            }
            _this6.state = _objectSpread(_objectSpread({}, _this6.state), {}, {
              verifyError: 'This server cannot send a verification email.'
            });
            _this6.paintSlide();
          });
        });
      } catch (err) {
        finish(function () {
          return _this6.showMailUnreachable();
        });
        return;
      }
      Promise.resolve(sent)["catch"](function () {
        finish(function () {
          return _this6.showMailUnreachable();
        });
      });
    }
  }, {
    key: "showMailUnreachable",
    value: function showMailUnreachable() {
      this.state = _objectSpread(_objectSpread({}, this.state), {}, {
        verifyError: 'error: mail server cannot be reached...'
      });
      this.paintSlide();
    }
  }, {
    key: "keepVerification",
    value: function () {
      var _keepVerification = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(res, email, publickey) {
        var verification, live, _t4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              verification = {
                publickey: res.publickey,
                message: res.message || "Request received for verification of email ".concat(email, " with publickey ").concat(publickey),
                signature: res.signature || ''
              };
              live = this.mod.document.users[this.state.you.index];
              if (live) {
                live.email = email;
                if (!live.publickey) {
                  live.publickey = publickey;
                }
                keepMethod(live, verification);
              }
              if (!res.signature) {
                _context6.n = 4;
                break;
              }
              _context6.p = 1;
              _context6.n = 2;
              return saveDraft({
                code: res.signature,
                document: copy(this.mod.document)
              });
            case 2:
              _context6.n = 4;
              break;
            case 3:
              _context6.p = 3;
              _t4 = _context6.v;
            case 4:
              this.state = flow.markMethodSent(this.state, 'email');
            case 5:
              return _context6.a(2);
          }
        }, _callee6, this, [[1, 3]]);
      }));
      function keepVerification(_x2, _x3, _x4) {
        return _keepVerification.apply(this, arguments);
      }
      return keepVerification;
    }()
  }, {
    key: "rememberDevCode",
    value: function rememberDevCode(res) {
      if (!this.mod.dev) {
        return;
      }
      var code = String(res && (res.signature || res.error) || '').trim();
      if (!code) {
        return;
      }
      this.state = _objectSpread(_objectSpread({}, this.state), {}, {
        devCode: code,
        pendingCode: code
      });
    }
  }, {
    key: "openProof",
    value: function openProof() {
      var proof = document.querySelector('[data-proof]');
      if (proof) {
        proof.hidden = false;
      }
    }
  }, {
    key: "submitSignature",
    value: function () {
      var _submitSignature = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _document$querySelect, _this$state$you4, _this$state$you5;
        var signature, email, publickey, valid, live;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              if (!this.state.checking) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              signature = ((_document$querySelect = document.querySelector('[data-verify-signature]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.value.trim()) || '';
              email = ((_this$state$you4 = this.state.you) === null || _this$state$you4 === void 0 ? void 0 : _this$state$you4.email) || '';
              publickey = ((_this$state$you5 = this.state.you) === null || _this$state$you5 === void 0 ? void 0 : _this$state$you5.publicKey) || '';
              if (!(!signature || !email || !publickey || !this.serverkey)) {
                _context7.n = 2;
                break;
              }
              this.state = _objectSpread(_objectSpread({}, this.state), {}, {
                pendingCode: signature,
                verifyError: 'Paste the cryptographic code from the email.'
              });
              this.paintSlide();
              return _context7.a(2);
            case 2:
              this.state = _objectSpread(_objectSpread({}, this.state), {}, {
                checking: true,
                pendingCode: signature,
                verifyError: ''
              });
              this.paintSlide();
              _context7.n = 3;
              return wait(700);
            case 3:
              valid = verifyEmailSignature(this.app, email, publickey, signature, this.serverkey);
              if (valid) {
                _context7.n = 4;
                break;
              }
              this.state = _objectSpread(_objectSpread({}, this.state), {}, {
                checking: false,
                pendingCode: signature,
                verifyError: 'That code could not be verified.'
              });
              this.paintSlide();
              return _context7.a(2);
            case 4:
              live = this.mod.document.users[this.state.you.index];
              if (live) {
                live.email = email;
                live.publickey = publickey;
                keepMethod(live, {
                  method: 'email',
                  publickey: this.serverkey,
                  message: "Request received for verification of email ".concat(email, " with publickey ").concat(publickey),
                  signature: signature
                });
              }
              saveDraft({
                code: signature,
                document: copy(this.mod.document)
              })["catch"](function () {});
              rememberEmail(this.app, publickey, email);
              this.state = flow.markMethodVerified(_objectSpread(_objectSpread({}, this.state), {}, {
                checking: false,
                pendingCode: '',
                verifyError: ''
              }), 'email');
              this.paintSlide();
            case 5:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function submitSignature() {
        return _submitSignature.apply(this, arguments);
      }
      return submitSignature;
    }()
  }, {
    key: "takePhoto",
    value: function takePhoto() {
      var _this7 = this;
      var photo = new Photo(this.app, this.mod);
      this.photo = photo;
      photo.open({
        onAccept: function onAccept(image) {
          return _this7.acceptPhoto(image);
        }
      });
    }
  }, {
    key: "acceptPhoto",
    value: function () {
      var _acceptPhoto = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(image) {
        var you, publickey, live, proof, verified, _t5;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              you = this.state.you;
              publickey = (you === null || you === void 0 ? void 0 : you.publicKey) || '';
              live = you ? this.mod.document.users[you.index] : null;
              if (!(!live || !publickey)) {
                _context8.n = 1;
                break;
              }
              photoNotice('That photo could not be saved.');
              return _context8.a(2);
            case 1:
              _context8.p = 1;
              _context8.n = 2;
              return verifyPhoto(this.app, publickey, image);
            case 2:
              proof = _context8.v;
              _context8.n = 4;
              break;
            case 3:
              _context8.p = 3;
              _t5 = _context8.v;
              photoNotice('That photo could not be saved.');
              return _context8.a(2);
            case 4:
              if (!live.publickey) {
                live.publickey = publickey;
              }
              keepMethod(live, proof);
              this.mod.document.edited = true;
              verified = flow.markMethodVerified(_objectSpread(_objectSpread({}, this.state), {}, {
                focus: 'photo',
                upsell: null,
                verifyError: ''
              }), 'photo');
              this.state = _objectSpread(_objectSpread({}, verified), {}, {
                verificationMethods: verified.verificationMethods.map(function (method) {
                  if (method.id !== 'photo') {
                    return method;
                  }
                  return _objectSpread(_objectSpread({}, method), {}, {
                    photo: proof.photo || image
                  });
                })
              });
              this.paintSlide();
            case 5:
              return _context8.a(2);
          }
        }, _callee8, this, [[1, 3]]);
      }));
      function acceptPhoto(_x5) {
        return _acceptPhoto.apply(this, arguments);
      }
      return acceptPhoto;
    }()
  }, {
    key: "acceptPassport",
    value: function () {
      var _acceptPassport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(image) {
        var you, publickey, live, proof, _t6;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              you = this.state.you;
              publickey = (you === null || you === void 0 ? void 0 : you.publicKey) || '';
              live = you ? this.mod.document.users[you.index] : null;
              if (!(!live || !publickey)) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2);
            case 1:
              _context9.p = 1;
              _context9.n = 2;
              return verifyPassport(this.app, publickey, image);
            case 2:
              proof = _context9.v;
              keepMethod(live, proof);
              this.mod.document.edited = true;
              this.state = _objectSpread(_objectSpread({}, flow.markMethodVerified(_objectSpread(_objectSpread({}, this.state), {}, {
                passportError: '',
                focus: 'passport'
              }), 'passport')), {}, {
                verificationMethods: this.state.verificationMethods.map(function (method) {
                  return method.id === 'passport' ? _objectSpread(_objectSpread({}, method), {}, {
                    status: 'verified',
                    selected: true,
                    image: proof.image
                  }) : method;
                })
              });
              this.paintSlide();
              _context9.n = 4;
              break;
            case 3:
              _context9.p = 3;
              _t6 = _context9.v;
              this.state = _objectSpread(_objectSpread({}, this.state), {}, {
                passportError: 'That passport image could not be verified.'
              });
              this.paintSlide();
            case 4:
              return _context9.a(2);
          }
        }, _callee9, this, [[1, 3]]);
      }));
      function acceptPassport(_x6) {
        return _acceptPassport.apply(this, arguments);
      }
      return acceptPassport;
    }()
  }, {
    key: "removePassport",
    value: function removePassport() {
      var you = this.state.you;
      var live = you ? this.mod.document.users[you.index] : null;
      if (!live) {
        return;
      }
      live.verifications = (live.verifications || []).filter(function (entry) {
        return (entry === null || entry === void 0 ? void 0 : entry.method) !== 'passport';
      });
      this.mod.document.edited = true;
      this.state = _objectSpread(_objectSpread({}, this.state), {}, {
        passportError: '',
        verificationMethods: this.state.verificationMethods.map(function (method) {
          return method.id === 'passport' ? _objectSpread(_objectSpread({}, method), {}, {
            status: 'pending',
            image: '',
            selected: true
          }) : method;
        })
      });
      this.paintSlide();
    }
  }, {
    key: "continueAfterVerification",
    value: function () {
      var _continueAfterVerification = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var _record$users2, _this$state$you6;
        var record, signature, _this$mod$main9, actionId;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              this.state = this.withKnownVerifications(this.state);
              if (!(!flow.requiredComplete(this.state) || this.sliding)) {
                _context0.n = 1;
                break;
              }
              this.paintSlide();
              return _context0.a(2);
            case 1:
              record = this.mod.document;
              signature = (record === null || record === void 0 || (_record$users2 = record.users) === null || _record$users2 === void 0 || (_record$users2 = _record$users2[(_this$state$you6 = this.state.you) === null || _this$state$you6 === void 0 ? void 0 : _this$state$you6.index]) === null || _record$users2 === void 0 || (_record$users2 = _record$users2.verifications) === null || _record$users2 === void 0 || (_record$users2 = _record$users2[0]) === null || _record$users2 === void 0 ? void 0 : _record$users2.signature) || '';
              if (signature) {
                saveDraft({
                  code: signature,
                  document: copy(record)
                })["catch"](function () {});
              }
              if (!(this.state.afterVerify === 'sign')) {
                _context0.n = 2;
                break;
              }
              actionId = this.state.pendingActionId;
              this.state = _objectSpread(_objectSpread({}, this.state), {}, {
                afterVerify: '',
                pendingActionId: null
              });
              this.close();
              this.refreshWorkspace();
              (_this$mod$main9 = this.mod.main) === null || _this$mod$main9 === void 0 || (_this$mod$main9 = _this$mod$main9.workspace) === null || _this$mod$main9 === void 0 || _this$mod$main9.continueSigning(actionId);
              return _context0.a(2);
            case 2:
              this.state = flow.resolveAfter(this.state, 'verify', this.workflowRequirements());
              this.state = this.summaryState(this.state);
              this.writeShare();
              this.refreshActions();
              this.showStep('forward');
            case 3:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function continueAfterVerification() {
        return _continueAfterVerification.apply(this, arguments);
      }
      return continueAfterVerification;
    }()
  }, {
    key: "summaryState",
    value: function summaryState(state) {
      var _state$you2,
        _record$document,
        _this8 = this;
      var record = this.mod.document;
      var userIndex = (_state$you2 = state.you) === null || _state$you2 === void 0 ? void 0 : _state$you2.index;
      var status = actionStatus(this.app, record === null || record === void 0 ? void 0 : record.actions, record === null || record === void 0 ? void 0 : record.users, userIndex, record);
      var creatorKey = this.normalizePublicKey(record === null || record === void 0 ? void 0 : record.creator);
      var pageCount = Number(record === null || record === void 0 || (_record$document = record.document) === null || _record$document === void 0 ? void 0 : _record$document.page_count) || 0;
      var signers = readUsers(this.mod).map(function (signer) {
        var signerStatus = actionStatus(_this8.app, record === null || record === void 0 ? void 0 : record.actions, record === null || record === void 0 ? void 0 : record.users, signer.index, record);
        return _objectSpread(_objectSpread({}, signer), {}, {
          places: signerStatus.mine,
          signed: signerStatus.mine > 0 && signerStatus.userComplete,
          creator: Boolean(creatorKey) && _this8.normalizePublicKey(signer.publickey) === creatorKey,
          requirements: requirementLines(record === null || record === void 0 ? void 0 : record.actions, signer.index, pageCount)
        });
      }).filter(function (signer) {
        return signer.places > 0;
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        signers: signers,
        signed: status.mine > 0 && status.userComplete,
        actionStatus: status,
        finalized: Boolean(record === null || record === void 0 ? void 0 : record.finalized)
      });
    }
  }, {
    key: "signUserActions",
    value: function () {
      var _signUserActions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var _this$state$you7,
          _this9 = this;
        var record, index, user, walletKey, privateKey, additions, addedIds;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              record = this.mod.document;
              if (record) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2, false);
            case 1:
              index = (_this$state$you7 = this.state.you) === null || _this$state$you7 === void 0 ? void 0 : _this$state$you7.index;
              if (!(!record || !Number.isInteger(index))) {
                _context1.n = 2;
                break;
              }
              return _context1.a(2, false);
            case 2:
              user = record.users[index];
              if (user) {
                _context1.n = 3;
                break;
              }
              return _context1.a(2, false);
            case 3:
              walletKey = this.currentPublicKey();
              if (!(!walletKey || walletKey !== this.normalizePublicKey(user.publickey))) {
                _context1.n = 4;
                break;
              }
              return _context1.a(2, false);
            case 4:
              if (verificationSatisfied(this.app, record, user)) {
                _context1.n = 5;
                break;
              }
              return _context1.a(2, false);
            case 5:
              if (commitmentIntact(this.app, record)) {
                _context1.n = 6;
                break;
              }
              return _context1.a(2, false);
            case 6:
              _context1.n = 7;
              return this.app.wallet.getPrivateKey();
            case 7:
              privateKey = _context1.v;
              additions = record.actions.filter(function (action) {
                return Number(action.user) === index && !verifyActionSignature(_this9.app, action, user, record);
              }).map(function (action) {
                if (action.type === 'signature') {
                  return addSignature(_this9.app, action, privateKey, record.hash);
                }
                if (action.type === 'initial') {
                  return addInitial(_this9.app, action, privateKey, record.hash);
                }
                return null;
              }).filter(function (entry) {
                return entry === null || entry === void 0 ? void 0 : entry.signature;
              });
              addedIds = new Set(additions.map(function (entry) {
                return Number(entry.id);
              }));
              user.signatures = (Array.isArray(user.signatures) ? user.signatures : []).filter(function (entry) {
                return !addedIds.has(Number(entry === null || entry === void 0 ? void 0 : entry.id));
              }).concat(additions);
              record.edited = true;
              return _context1.a(2, true);
          }
        }, _callee1, this);
      }));
      function signUserActions() {
        return _signUserActions.apply(this, arguments);
      }
      return signUserActions;
    }()
  }, {
    key: "refreshActions",
    value: function refreshActions() {
      var _this$mod$main0;
      var root = document.querySelector('.saito-container > .workspace');
      if (root && (_this$mod$main0 = this.mod.main) !== null && _this$mod$main0 !== void 0 && _this$mod$main0.workspace) {
        this.mod.main.workspace.update(root);
      }
    }
  }, {
    key: "paintSlide",
    value: function paintSlide() {
      if (this.state.step === 'verify') {
        this.state = this.withKnownVerifications(this.state);
      }
      var previous = document.querySelector('.saitosign-publish .actions [data-publish-action="advance"]');
      var wasDisabled = !previous || previous.disabled;
      var panel = document.querySelector('#saitosign-publish-step');
      var actionBar = document.querySelector('.saitosign-publish .actions');
      var temp = document.createElement('div');
      temp.innerHTML = PublishTemplate(this.state).trim();
      var next = temp.querySelector('#saitosign-publish-step');
      var nextActions = temp.querySelector('.saitosign-publish .actions');
      if (next && panel) {
        panel.replaceWith(next);
      }
      if (nextActions && actionBar) {
        actionBar.replaceWith(nextActions);
      }
      var button = document.querySelector('.saitosign-publish .actions [data-publish-action="advance"]');
      if (button && wasDisabled && !button.disabled) {
        button.classList.add('continue-activate');
      }
    }
  }, {
    key: "showVerifyNote",
    value: function showVerifyNote(text) {
      var row = document.querySelector('.saitosign-publish .send-row');
      if (!row) {
        return;
      }
      var note = row.parentElement.querySelector('[data-sent-note]');
      if (!note) {
        note = document.createElement('p');
        note.className = 'note';
        note.dataset.sentNote = '1';
        row.insertAdjacentElement('afterend', note);
      }
      note.textContent = text;
    }
  }, {
    key: "showBackup",
    value: function showBackup() {
      var _this$state$you8;
      var note = document.querySelector('[data-backup-note]');
      var key = ((_this$state$you8 = this.state.you) === null || _this$state$you8 === void 0 ? void 0 : _this$state$you8.publicKey) || '';
      if (!note || !key) {
        return;
      }
      note.hidden = false;
      note.textContent = key;
    }
  }, {
    key: "paintContinue",
    value: function paintContinue() {
      var button = document.querySelector('.saitosign-publish .actions [data-publish-action="advance"]');
      if (!button) {
        return;
      }
      var ready = this.canContinue();
      var wasDisabled = button.disabled;
      button.disabled = !ready;
      button.classList.toggle('saito-button-primary', ready);
      button.classList.toggle('saito-button-secondary', !ready);
      if (ready && wasDisabled) {
        button.classList.remove('continue-activate');
        void button.offsetWidth;
        button.classList.add('continue-activate');
      }
    }
  }, {
    key: "canContinue",
    value: function canContinue() {
      if (this.state.step === 'sign') {
        return Boolean(this.state.identified);
      }
      if (this.state.step === 'verify') {
        return flow.requiredComplete(this.state);
      }
      return true;
    }
  }]);
}();
function mailServerReachable(app) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return false;
  }
  var peers = app.network && app.network.peers;
  if (Array.isArray(peers) && peers.length === 0) {
    return false;
  }
  return true;
}
function signaturePlaces(mod, index) {
  var _mod$document, _mod$document2;
  var user = (_mod$document = mod.document) === null || _mod$document === void 0 || (_mod$document = _mod$document.users) === null || _mod$document === void 0 ? void 0 : _mod$document[index];
  return (((_mod$document2 = mod.document) === null || _mod$document2 === void 0 ? void 0 : _mod$document2.actions) || []).filter(function (action) {
    if (Number(action.user) !== index) {
      return false;
    }
    if (action.type !== 'signature' && action.type !== 'initial') {
      return false;
    }
    return !verifyActionSignature(mod.app, action, user, mod.document);
  }).length;
}
function firstUnsignedActionId(app, record, userIndex) {
  var _record$users3;
  var user = record === null || record === void 0 || (_record$users3 = record.users) === null || _record$users3 === void 0 ? void 0 : _record$users3[userIndex];
  var action = ((record === null || record === void 0 ? void 0 : record.actions) || []).find(function (item) {
    return Number(item.user) === userIndex && (item.type === 'signature' || item.type === 'initial') && !verifyActionSignature(app, item, user, record);
  });
  return Number.isInteger(Number(action === null || action === void 0 ? void 0 : action.id)) ? Number(action.id) : null;
}
function shareRowsForWho(state) {
  return (state.signers || []).filter(function (signer) {
    return Number(signer.places) > 0;
  }).map(function (signer) {
    return {
      index: signer.index,
      name: signer.name || signer.email || 'Signer',
      email: signer.email || ''
    };
  });
}
function readUsers(mod) {
  var _mod$document3;
  var list = ((_mod$document3 = mod.document) === null || _mod$document3 === void 0 ? void 0 : _mod$document3.users) || [];
  return list.map(function (user, index) {
    var name = String((user === null || user === void 0 ? void 0 : user.name) || '').trim();
    var email = String((user === null || user === void 0 ? void 0 : user.email) || '').trim() || (isEmailAddress(name) ? name : '');
    return {
      index: index,
      name: email && email === name ? nameFromEmail(email) : name,
      email: email,
      publickey: (user === null || user === void 0 ? void 0 : user.publickey) || ''
    };
  });
}
function storedPhoto(user) {
  var entries = Array.isArray(user === null || user === void 0 ? void 0 : user.verifications) ? user.verifications : [];
  var entry = entries.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.method) === 'photo' && typeof item.photo === 'string';
  });
  var image = String((entry === null || entry === void 0 ? void 0 : entry.photo) || '').trim();
  return image.startsWith('data:image/') ? image : '';
}
function storedPassport(user) {
  var entries = Array.isArray(user === null || user === void 0 ? void 0 : user.verifications) ? user.verifications : [];
  var entry = entries.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.method) === 'passport' && typeof item.image === 'string';
  });
  var image = String((entry === null || entry === void 0 ? void 0 : entry.image) || '').trim();
  return image.startsWith('data:image/') ? image : '';
}
function photoNotice(message) {
  if (typeof siteMessage === 'function') {
    siteMessage(message, 3000);
  }
}
function keepMethod(user, entry) {
  var method = String((entry === null || entry === void 0 ? void 0 : entry.method) || '');
  var kept = (user.verifications || []).filter(function (item) {
    if (!item.method) {
      return false;
    }
    if (!method) {
      return item.method !== 'email';
    }
    return item.method !== method;
  });
  kept.push(entry);
  user.verifications = kept;
}
function duplicateSignerNotice() {
  if (typeof siteMessage === 'function') {
    siteMessage('Adding multiple users with the same email address is not permitted.', 3000);
  }
}
function isEmailAddress(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || ''));
}
function nameFromEmail(email) {
  return String(email).split('@')[0].replace(/[._+-]+/g, ' ').replace(/\s+/g, ' ').trim();
}
function escapeHTML(value) {
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function wait(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}
module.exports = PublishOverlay;